import mapResponseToTaxes from './mappers/mapResponseToTaxes'
import { ITaxesDictionary } from './index'

export default function updateTaxes(api: GlobalFetch) {
  return async function(dict: ITaxesDictionary[]) {
    const requestBody = {
      rates: dict.map(d => ({
        deleted: Number(d.deleted),
        id: d.id,
        rate: d.rate,
      })),
    }

    const buildUrl = `/api/v2/invoice/rates/`
    const response = await api.fetch(buildUrl, {
      body: JSON.stringify(requestBody),
      method: 'POST',
    })
    const responseBody: IData = await response.json()

    return mapResponseToTaxes(responseBody)
  }
}

export interface IData {
  messages: string[]
  items: IItemData[]
}

interface IItemData {
  id: string
  id_object: string
  rate: number
  deleted: string
  created_at: string
  updated_at: string
}
